import { render } from "./PartyLedgerOld.vue?vue&type=template&id=57b3dc10&scoped=true"
import script from "./PartyLedgerOld.vue?vue&type=script&lang=js"
export * from "./PartyLedgerOld.vue?vue&type=script&lang=js"

import "./PartyLedgerOld.vue?vue&type=style&index=0&id=57b3dc10&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b3dc10"]])

export default __exports__